module.exports = __webpack_public_path__ + "static/media/icon-fashion_men-full.9ba34799.png";